import PropTypes from 'prop-types'
import { CATEGORY_TYPE, CATEGORIES_TYPE } from 'types/categories'

export const CHAPTER_SUB_TYPE = PropTypes.oneOf(['chapter', 'episode'])

export const CHAPTER_TYPE = PropTypes.shape({
  abstract: PropTypes.string,
  duration: PropTypes.string,
  id: PropTypes.number.isRequired,
  number: PropTypes.number,
  title: PropTypes.string,
  type: CHAPTER_SUB_TYPE,
})

export const SAMPLE_TYPE = PropTypes.shape({
  brightcoveVideoId: PropTypes.string,
  mediaUuid: PropTypes.string,
})

export const COURSE_SUB_TYPE = PropTypes.oneOf(['camp', 'course', 'series'])

export const COURSE_TYPE = PropTypes.shape({
  brightcoveVideoId: PropTypes.string,
  mediaUuid: PropTypes.string,
  categories: CATEGORIES_TYPE,
  chapters: PropTypes.arrayOf(CHAPTER_TYPE),
  cinematic12x5: PropTypes.string,
  headline: PropTypes.string,
  id: PropTypes.number.isRequired,
  instructorName: PropTypes.string,
  marketingCmColumn: PropTypes.string,
  marketingOverview: PropTypes.string,
  nameplate: PropTypes.string,
  primary1x1: PropTypes.string,
  primary2x3: PropTypes.string,
  primary16x9: PropTypes.string,
  primaryCategory: CATEGORY_TYPE,
  sample: SAMPLE_TYPE,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  overview: PropTypes.string,
  type: COURSE_SUB_TYPE,
})

export const COURSES_TYPE = PropTypes.arrayOf(COURSE_TYPE)

export const FOR_BUSINESS_COURSE_TYPE = PropTypes.shape({
  id: PropTypes.number.isRequired,
  instructorName: PropTypes.string,
  nameplateUrl: PropTypes.string,
  instructorHeadshotUrl: PropTypes.string,
  slug: PropTypes.string.isRequired,
  skill: PropTypes.string.isRequired,
  enterpriseBio: PropTypes.string.isRequired,
})

export const SESSION_TYPE = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    nameplateTitle: PropTypes.string.isRequired,
    nameplateImage: PropTypes.string.isRequired,
    nameplateSvg: PropTypes.string.isRequired,
    instructors: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        primary1x1: PropTypes.string.isRequired,
      }),
    ),
    primary1x1: PropTypes.string,
    primary2x3: PropTypes.string,
    primary16x9: PropTypes.string,
    state: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    totalProjects: PropTypes.string.isRequired,
  }),
)
